{
	"fixed": {
		"style": {
			"position": "fixed"
		}
	},
	"absolute": {
		"style": {
			"position": "absolute"
		}
	},
	"relative": {
		"style": {
			"position": "relative"
		}
	},
	"inset-x-0": {
		"style": {
			"left": 0,
			"right": 0
		}
	},
	"-right-2.5": {
		"style": {
			"right": -10
		}
	},
	"-top-2.5": {
		"style": {
			"top": -10
		}
	},
	"bottom-0": {
		"style": {
			"bottom": 0
		}
	},
	"bottom-16": {
		"style": {
			"bottom": 64
		}
	},
	"left-0": {
		"style": {
			"left": 0
		}
	},
	"right-0": {
		"style": {
			"right": 0
		}
	},
	"right-2": {
		"style": {
			"right": 8
		}
	},
	"right-6": {
		"style": {
			"right": 24
		}
	},
	"top-0": {
		"style": {
			"top": 0
		}
	},
	"top-2": {
		"style": {
			"top": 8
		}
	},
	"top-6": {
		"style": {
			"top": 24
		}
	},
	"z-50": {
		"style": {
			"zIndex": 50
		}
	},
	"-m-1": {
		"style": {
			"marginTop": -4,
			"marginRight": -4,
			"marginBottom": -4,
			"marginLeft": -4
		}
	},
	"m-0": {
		"style": {
			"marginTop": 0,
			"marginRight": 0,
			"marginBottom": 0,
			"marginLeft": 0
		}
	},
	"m-1": {
		"style": {
			"marginTop": 4,
			"marginRight": 4,
			"marginBottom": 4,
			"marginLeft": 4
		}
	},
	"m-2": {
		"style": {
			"marginTop": 8,
			"marginRight": 8,
			"marginBottom": 8,
			"marginLeft": 8
		}
	},
	"m-3": {
		"style": {
			"marginTop": 12,
			"marginRight": 12,
			"marginBottom": 12,
			"marginLeft": 12
		}
	},
	"m-4": {
		"style": {
			"marginTop": 16,
			"marginRight": 16,
			"marginBottom": 16,
			"marginLeft": 16
		}
	},
	"m-5": {
		"style": {
			"marginTop": 20,
			"marginRight": 20,
			"marginBottom": 20,
			"marginLeft": 20
		}
	},
	"-mx-2": {
		"style": {
			"marginLeft": -8,
			"marginRight": -8
		}
	},
	"-mx-4": {
		"style": {
			"marginLeft": -16,
			"marginRight": -16
		}
	},
	"-mx-px": {
		"style": {
			"marginLeft": -1,
			"marginRight": -1
		}
	},
	"mx-0.5": {
		"style": {
			"marginLeft": 2,
			"marginRight": 2
		}
	},
	"mx-2": {
		"style": {
			"marginLeft": 8,
			"marginRight": 8
		}
	},
	"mx-3": {
		"style": {
			"marginLeft": 12,
			"marginRight": 12
		}
	},
	"mx-4": {
		"style": {
			"marginLeft": 16,
			"marginRight": 16
		}
	},
	"mx-6": {
		"style": {
			"marginLeft": 24,
			"marginRight": 24
		}
	},
	"mx-8": {
		"style": {
			"marginLeft": 32,
			"marginRight": 32
		}
	},
	"my-1": {
		"style": {
			"marginTop": 4,
			"marginBottom": 4
		}
	},
	"my-4": {
		"style": {
			"marginTop": 16,
			"marginBottom": 16
		}
	},
	"my-6": {
		"style": {
			"marginTop": 24,
			"marginBottom": 24
		}
	},
	"my-8": {
		"style": {
			"marginTop": 32,
			"marginBottom": 32
		}
	},
	"-ml-1": {
		"style": {
			"marginLeft": -4
		}
	},
	"-mr-2": {
		"style": {
			"marginRight": -8
		}
	},
	"-mr-4": {
		"style": {
			"marginRight": -16
		}
	},
	"-mt-4": {
		"style": {
			"marginTop": -16
		}
	},
	"mb-1": {
		"style": {
			"marginBottom": 4
		}
	},
	"mb-12": {
		"style": {
			"marginBottom": 48
		}
	},
	"mb-2": {
		"style": {
			"marginBottom": 8
		}
	},
	"mb-24": {
		"style": {
			"marginBottom": 96
		}
	},
	"mb-3": {
		"style": {
			"marginBottom": 12
		}
	},
	"mb-4": {
		"style": {
			"marginBottom": 16
		}
	},
	"mb-40": {
		"style": {
			"marginBottom": 160
		}
	},
	"mb-8": {
		"style": {
			"marginBottom": 32
		}
	},
	"mb-px": {
		"style": {
			"marginBottom": 1
		}
	},
	"ml-1": {
		"style": {
			"marginLeft": 4
		}
	},
	"ml-2": {
		"style": {
			"marginLeft": 8
		}
	},
	"ml-4": {
		"style": {
			"marginLeft": 16
		}
	},
	"mr-1": {
		"style": {
			"marginRight": 4
		}
	},
	"mr-1.5": {
		"style": {
			"marginRight": 6
		}
	},
	"mr-2": {
		"style": {
			"marginRight": 8
		}
	},
	"mr-3": {
		"style": {
			"marginRight": 12
		}
	},
	"mr-4": {
		"style": {
			"marginRight": 16
		}
	},
	"mt-0.5": {
		"style": {
			"marginTop": 2
		}
	},
	"mt-1": {
		"style": {
			"marginTop": 4
		}
	},
	"mt-2": {
		"style": {
			"marginTop": 8
		}
	},
	"mt-3": {
		"style": {
			"marginTop": 12
		}
	},
	"mt-4": {
		"style": {
			"marginTop": 16
		}
	},
	"mt-8": {
		"style": {
			"marginTop": 32
		}
	},
	"flex": {
		"style": {
			"display": "flex"
		}
	},
	"hidden": {
		"style": {
			"display": "none"
		}
	},
	"h-1": {
		"style": {
			"height": 4
		}
	},
	"h-10": {
		"style": {
			"height": 40
		}
	},
	"h-12": {
		"style": {
			"height": 48
		}
	},
	"h-36": {
		"style": {
			"height": 144
		}
	},
	"h-40": {
		"style": {
			"height": 160
		}
	},
	"h-6": {
		"style": {
			"height": 24
		}
	},
	"h-8": {
		"style": {
			"height": 32
		}
	},
	"w-10": {
		"style": {
			"width": 40
		}
	},
	"w-6": {
		"style": {
			"width": 24
		}
	},
	"w-8": {
		"style": {
			"width": 32
		}
	},
	"w-full": {
		"style": {
			"width": "100%"
		}
	},
	"flex-1": {
		"style": {
			"flexGrow": 1,
			"flexShrink": 1,
			"flexBasis": "0%"
		}
	},
	"flex-shrink": {
		"style": {
			"flexShrink": 1
		}
	},
	"flex-shrink-0": {
		"style": {
			"flexShrink": 0
		}
	},
	"flex-grow-0": {
		"style": {
			"flexGrow": 0
		}
	},
	"flex-row": {
		"style": {
			"flexDirection": "row"
		}
	},
	"flex-col": {
		"style": {
			"flexDirection": "column"
		}
	},
	"flex-wrap": {
		"style": {
			"flexWrap": "wrap"
		}
	},
	"items-end": {
		"style": {
			"alignItems": "flex-end"
		}
	},
	"items-center": {
		"style": {
			"alignItems": "center"
		}
	},
	"justify-start": {
		"style": {
			"justifyContent": "flex-start"
		}
	},
	"justify-end": {
		"style": {
			"justifyContent": "flex-end"
		}
	},
	"justify-center": {
		"style": {
			"justifyContent": "center"
		}
	},
	"justify-between": {
		"style": {
			"justifyContent": "space-between"
		}
	},
	"justify-evenly": {
		"style": {
			"justifyContent": "space-evenly"
		}
	},
	"gap-1": {
		"style": {
			"gap": 4
		}
	},
	"gap-2": {
		"style": {
			"gap": 8
		}
	},
	"gap-3": {
		"style": {
			"gap": 12
		}
	},
	"gap-4": {
		"style": {
			"gap": 16
		}
	},
	"gap-8": {
		"style": {
			"gap": 32
		}
	},
	"self-start": {
		"style": {
			"alignSelf": "flex-start"
		}
	},
	"self-end": {
		"style": {
			"alignSelf": "flex-end"
		}
	},
	"self-center": {
		"style": {
			"alignSelf": "center"
		}
	},
	"overflow-hidden": {
		"style": {
			"overflow": "hidden"
		}
	},
	"rounded": {
		"style": {
			"borderTopLeftRadius": 4,
			"borderTopRightRadius": 4,
			"borderBottomRightRadius": 4,
			"borderBottomLeftRadius": 4
		}
	},
	"rounded-full": {
		"style": {
			"borderTopLeftRadius": 9999,
			"borderTopRightRadius": 9999,
			"borderBottomRightRadius": 9999,
			"borderBottomLeftRadius": 9999
		}
	},
	"rounded-lg": {
		"style": {
			"borderTopLeftRadius": 8,
			"borderTopRightRadius": 8,
			"borderBottomRightRadius": 8,
			"borderBottomLeftRadius": 8
		}
	},
	"rounded-md": {
		"style": {
			"borderTopLeftRadius": 6,
			"borderTopRightRadius": 6,
			"borderBottomRightRadius": 6,
			"borderBottomLeftRadius": 6
		}
	},
	"rounded-xl": {
		"style": {
			"borderTopLeftRadius": 12,
			"borderTopRightRadius": 12,
			"borderBottomRightRadius": 12,
			"borderBottomLeftRadius": 12
		}
	},
	"border": {
		"style": {
			"borderTopWidth": 1,
			"borderRightWidth": 1,
			"borderBottomWidth": 1,
			"borderLeftWidth": 1
		}
	},
	"border-2": {
		"style": {
			"borderTopWidth": 2,
			"borderRightWidth": 2,
			"borderBottomWidth": 2,
			"borderLeftWidth": 2
		}
	},
	"border-b": {
		"style": {
			"borderBottomWidth": 1
		}
	},
	"bg-primary-500": {
		"style": {
			"--tw-bg-opacity": 1,
			"backgroundColor": "rgb(27 163 156 / var(--tw-bg-opacity, 1))"
		}
	},
	"bg-red-100": {
		"style": {
			"--tw-bg-opacity": 1,
			"backgroundColor": "rgb(252 218 218 / var(--tw-bg-opacity, 1))"
		}
	},
	"p-0": {
		"style": {
			"paddingTop": 0,
			"paddingRight": 0,
			"paddingBottom": 0,
			"paddingLeft": 0
		}
	},
	"p-2": {
		"style": {
			"paddingTop": 8,
			"paddingRight": 8,
			"paddingBottom": 8,
			"paddingLeft": 8
		}
	},
	"p-3": {
		"style": {
			"paddingTop": 12,
			"paddingRight": 12,
			"paddingBottom": 12,
			"paddingLeft": 12
		}
	},
	"p-4": {
		"style": {
			"paddingTop": 16,
			"paddingRight": 16,
			"paddingBottom": 16,
			"paddingLeft": 16
		}
	},
	"p-6": {
		"style": {
			"paddingTop": 24,
			"paddingRight": 24,
			"paddingBottom": 24,
			"paddingLeft": 24
		}
	},
	"px-1.5": {
		"style": {
			"paddingLeft": 6,
			"paddingRight": 6
		}
	},
	"px-12": {
		"style": {
			"paddingLeft": 48,
			"paddingRight": 48
		}
	},
	"px-2": {
		"style": {
			"paddingLeft": 8,
			"paddingRight": 8
		}
	},
	"px-3": {
		"style": {
			"paddingLeft": 12,
			"paddingRight": 12
		}
	},
	"px-4": {
		"style": {
			"paddingLeft": 16,
			"paddingRight": 16
		}
	},
	"px-6": {
		"style": {
			"paddingLeft": 24,
			"paddingRight": 24
		}
	},
	"py-0.5": {
		"style": {
			"paddingTop": 2,
			"paddingBottom": 2
		}
	},
	"py-2": {
		"style": {
			"paddingTop": 8,
			"paddingBottom": 8
		}
	},
	"py-3": {
		"style": {
			"paddingTop": 12,
			"paddingBottom": 12
		}
	},
	"py-4": {
		"style": {
			"paddingTop": 16,
			"paddingBottom": 16
		}
	},
	"py-8": {
		"style": {
			"paddingTop": 32,
			"paddingBottom": 32
		}
	},
	"pb-24": {
		"style": {
			"paddingBottom": 96
		}
	},
	"pb-8": {
		"style": {
			"paddingBottom": 32
		}
	},
	"pl-2": {
		"style": {
			"paddingLeft": 8
		}
	},
	"pl-3": {
		"style": {
			"paddingLeft": 12
		}
	},
	"pr-3": {
		"style": {
			"paddingRight": 12
		}
	},
	"pt-0.5": {
		"style": {
			"paddingTop": 2
		}
	},
	"pt-1": {
		"style": {
			"paddingTop": 4
		}
	},
	"pt-4": {
		"style": {
			"paddingTop": 16
		}
	},
	"text-left": {
		"style": {
			"textAlign": "left"
		}
	},
	"text-center": {
		"style": {
			"textAlign": "center"
		}
	},
	"text-right": {
		"style": {
			"textAlign": "right"
		}
	},
	"text-xs": {
		"style": {
			"fontSize": 12,
			"lineHeight": 16
		}
	},
	"font-bold": {
		"style": {
			"fontWeight": "700"
		}
	},
	"font-medium": {
		"style": {
			"fontWeight": "500"
		}
	},
	"font-semibold": {
		"style": {
			"fontWeight": "600"
		}
	},
	"leading-10": {
		"style": {
			"lineHeight": 40
		}
	},
	"text-white": {
		"style": {
			"--tw-text-opacity": 1,
			"color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
		}
	},
	"line-through": {
		"style": {
			"textDecorationLine": "line-through"
		}
	},
	"opacity-0": {
		"style": {
			"opacity": 0
		}
	},
	"outline": {
		"style": {
			"outlineStyle": "solid"
		}
	}
}